import React, { useState, useRef } from "react";
import "./Contracting.css"; // Custom CSS for styling the form
import logoSrc from "../img/logo.png";
import ContactForm from "../ContactForm"; // Make sure this component has the `openForm` method.

const ContractForm = () => {
  const contactFormRef = useRef(); // Reference for controlling the contact form
  const [snackbar, setSnackbar] = useState({
    message: "",
    show: false,
    type: "success",
  });

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    phone: "",
    address: "",
    email: "",
    companyName: "",
    position: "",
    industry: "",
    problemSolved: "",
    needsRequirements: "",
    budget: "",
    paymentProcess: "",
    referralCode: "",
    questions: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form data:", formData);

    try {
      const response = await fetch(
        "https://apiqms.shigjeta.com/api/forms/contract/submit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        console.log("Server response:", responseData);
        // Show success snackbar
        setSnackbar({
          message: "Application submitted successfully!",
          show: true,
          type: "success",
        });
      } else {
        const errorData = await response.json();
        console.log("Error response:", errorData);
        // Show error snackbar
        setSnackbar({
          message: errorData.message || "An error occurred. Please try again.",
          show: true,
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // Show error snackbar
      setSnackbar({
        message: "An error occurred. Please try again.",
        show: true,
        type: "error",
      });
    }
  };
  // Snackbar styling
  const snackbarStyle = {
    position: "fixed",
    top: "20px", // Move it to the top
    left: "50%", // Center horizontally
    transform: "translateX(-50%)", // Adjust to perfectly center
    backgroundColor: snackbar.type === "success" ? "#16a085" : "#e74c3c", // Green for success, red for error
    color: "white",
    padding: "15px 30px",
    borderRadius: "8px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1001,
    animation: "fadeIn 0.5s ease-out",
  };

  const dismissButtonStyle = {
    background: "none",
    border: "none",
    color: "white",
    cursor: "none",
    fontSize: "16px",
    cursor: "none",
    fontWeight: "bold",
    marginLeft: "15px", // Adds a gap between the text and the button
  };

  // Close snackbar after 5 seconds
  setTimeout(() => {
    if (snackbar.show) {
      setSnackbar({ ...snackbar, show: false });
    }
  }, 5000);
  return (
    <>
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Formular Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">
              smooth partnership agreements.
            </h1>
            <p className="banner-description">
              Submit your contract details and start the process today.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>
      <div className="img-background">
        <img
          className="img"
          id="banner1-video"
          src="/img/Contracting Thumbnail.png" // This should be correct if the video is in the public folder
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error("Error loading video:", e)} // Error logging for debugging
        />
      </div>
      {/* Form Section */}
      <h3 className="textForm">Shigjeta LLC - Formular for contract</h3>
      <section className="contract-form-container">
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="divFlexField">
            <div className="form-group">
              <label htmlFor="name">First Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your first name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>
            <div className="form-group">
              <label htmlFor="address">Company Address</label>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter company address"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter company name"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label htmlFor="position">Position in Company</label>
              <input
                type="text"
                id="position"
                name="position"
                value={formData.position}
                onChange={handleChange}
                placeholder="Enter your position"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="industry">Industry</label>
              <input
                type="text"
                id="industry"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                placeholder="Enter industry"
                required
              />
            </div>
          </div>

          {/* Problem to Be Solved */}
          <div className="form-group">
            <label htmlFor="problemSolved">Problem to Be Solved</label>
            <textarea
              id="problemSolved"
              name="problemSolved"
              value={formData.problemSolved}
              onChange={handleChange}
              placeholder="Describe the problem"
              required
            />
          </div>

          {/* Requirements */}
          <div className="form-group">
            <label htmlFor="needsRequirements">Requirements</label>
            <textarea
              id="needsRequirements"
              name="needsRequirements"
              value={formData.needsRequirements}
              onChange={handleChange}
              placeholder="List your requirements"
              required
            />
          </div>

          <div className="divFlexFieldLst">
            <div className="form-group">
              <label htmlFor="budget">Budget</label>
              <input
                type="text"
                id="budget"
                name="budget"
                value={formData.budget}
                onChange={handleChange}
                placeholder="Enter budget"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="paymentProcess">Payment Process</label>
              <select
                id="paymentProcess"
                name="paymentProcess"
                value={formData.paymentProcess}
                onChange={handleChange}
              >
                <option value="milestones">In 2 Milestones 50-50</option>
                <option value="full">In 3 Milestones 50-25-25</option>
              </select>
            </div>
          </div>

          {/* Referral Code */}
          <div className="form-group">
            <label htmlFor="referralCode">Referral Code (Optional)</label>
            <input
              type="text"
              id="referralCode"
              name="referralCode"
              value={formData.referralCode}
              onChange={handleChange}
              placeholder="Enter referral code"
            />
          </div>

          {/* Questions */}
          <div className="form-group">
            <label htmlFor="questions">Questions</label>
            <textarea
              id="questions"
              name="questions"
              value={formData.questions}
              onChange={handleChange}
              placeholder="Ask your questions here"
            />
          </div>

          {/* Submit Button */}
          <button type="submit" className="submit-button">
            Submit Application
          </button>
        </form>
      </section>
      {/* Snackbar display */}
      {snackbar.show && (
        <div style={snackbarStyle}>
          <span>{snackbar.message}</span>
          <button
            onClick={() => setSnackbar({ ...snackbar, show: false })}
            style={dismissButtonStyle}
          >
            X
          </button>
        </div>
      )}
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default ContractForm;
